module.exports = __webpack_public_path__ + "img/online.bc411fd4.png";